'use client';

import { useTranslations } from 'next-intl';
import type React from 'react';
import { useEffect, useState } from 'react';
import styles from './LoadingSpinner.module.css';
import type { LoadingSpinnerProps } from './LoadingSpinner.types';

const LoadingSpinner = ({
  title,
  isLoading = false,
  isFinished = false,
  size = 'medium',
  margin,
  ...props
}: LoadingSpinnerProps) => {
  type BoxStyle = React.CSSProperties & { '--ls-margin'?: string };
  const t = useTranslations('common');
  const resolvedTitle = title ?? t('loading');
  const [display, setDisplay] = useState(true);
  const [currentText, setCurrentText] = useState<string | null>(resolvedTitle);

  useEffect(() => {
    if (isFinished) {
      setCurrentText(t('finishing'));
      const finishedTimer = setTimeout(() => {
        setDisplay(false);
      }, 50);
      return () => clearTimeout(finishedTimer);
    }
  }, [isFinished]);

  const chipStyle: BoxStyle | undefined = margin ? { '--ls-margin': `var(${margin})` } : undefined;

  return (
    <div className={`${styles.container} ${!display ? styles.fadeOut : ''}`}>
      <div className={styles.chip} style={chipStyle}>
        <svg
          width="36"
          height="36"
          viewBox="0 0 100 100"
          aria-label={resolvedTitle}
          className={styles.spinner}
          {...props}
        >
          <title>{resolvedTitle}</title>
          <circle className={styles.tinted} cx="50" cy="50" r="30" />
          <circle className={styles.solid} cx="50" cy="50" r="30" />
        </svg>

        {resolvedTitle && <span className={styles.title}>{currentText}</span>}
      </div>
    </div>
  );
};

export { LoadingSpinner };
